<div *ngIf="!error" class="container">
    <h1>{{capitalize(cloudService)}} Creation in Progress</h1>
    <h2>
        Here is your {{cloudName}} {{cloudService}} information. <b>The {{cloudService}} creation is in progress,</b> you will receive an email once the {{cloudService}} status is <i>Active</i>.
    </h2>
    
    <account-summary [account]="account"></account-summary>

    <button [matDialogClose] mat-button class="button" (click)="close()">Got it</button>

</div>

<div class="container" *ngIf="error">
    <h1>Account Failed to Created</h1>
    <h2>
        Your {{cloudName}} {{cloudService}} has failed to be created.
        Please contact the Maxis team on Viva Engage at <a [href]="yammerUrl">Maxis Cloud AI & Analytics</a>
    </h2>

    <button [matDialogClose] mat-button class="button" (click)="close()">Got it</button>

</div>